import * as model from './model';
import * as view from './view';
import * as navigation from './viewStep/navigation';
import * as typeOfVisa from './viewStep/typeOfVisa';
import * as personalInformation from './viewStep/personalInformation';
import * as loadingFile from "./viewStep/loadingFile";
// import * as previousVisas from "./viewStep/previousVisas";
import * as previousVisasNew from "./viewStep/previousVisasNew";
import * as travelPlans from "./viewStep/travelPlans";
import * as insurance from "./viewStep/insurance";
import * as specialOffers from "./viewStep/specialOffers";
import * as payment from "./viewStep/payment";

// import * as contactInformation from "./viewStep/contactInformation";

export default function (){
    window.JCDwsFormEVisaIran = function (arParams)
    {
        this.errorCode = 0;
        this.visual = {};
        this.debug = {};

        if (arParams.CONFIG.DEBUG === 'Y') {
            this.debug = {
                logDataResul: true, // Печать данных перед отправкой
                errorModal: true, //* Модальное окно ERROR
                notSetBxAjaxResult: false, // Отключить функция Ajax (true / false)
                getAjaxLog: true, //* печать данных после ответа Ajaxс с сервера
                notDelLocalStorageAjax: true, //* Не удаляем данные с LS после отправки в Ajax
                notLocation: true, //* Отключить перенаправление на другую страницу
                application: {
                    stepCollectionPropLogDie: true, // Коллекция данных ($PROP, $CRM, $COMMENTS, $PARAMS)
                    addElementLogDie: false, // Не отправляем данных на сайт (если будет true то в CRM не отправится)
                    restTest: false, //* подключаем тестовый CRM
                    setDataVisaCrmLogDie: false, // Останавливаем сбор данных после отправки в CRM
                    addContactCrmStopLogDie: false, //* Останавливаем после создание контакта в СРМ
                    leadCrmLogDie: false, // Остановить перед созданием лида
                    updateElementOfCrmVisaStop: false, // Не обновляем данные на сайте
                    sendingEmailStop: false, // Останавливаем отправка письма пользователю
                    logResultDie: false, // Выводим на печать общий массив
                    testCodeResultDie: false, // Дебажим данные в любой точке кода
                }
            }
        }

        this.data = {
            step: 1,
            btnNext: false,
            filesFlag: false,
            dataForm: {
              step1: {
                  id: false,
                  name: false,
                  prise: false,
                  method: false,
                  userConsent: false,
                  locationVisaRefer: false,
                  referId: false,
                  relativesIran: false,
                  relativesIranId: false
                },
                step2: {
                    date: false,
                    dateRFC2822: false,
                    age: false,
                    surname: false,
                    name: false,
                    fatherName: false,
                    profession: false,
                    familyStatus: false,
                    familyStatusId: false,
                    phone: false,
                    addressRegistration: false,
                    businessVisa: {}
                },
                step3: {
                    name: false,
                    size: false,
                    type: false,
                    path: false,
                    files: false,
                },
                step4: {
                    name: false,
                    size: false,
                    type: false,
                    path: false,
                    files: false,
                },
                // step5: {
                //     phone: false,
                //     addressRegistration: false,
                // },
                /*step5: {
                    month: false,
                    year: false,
                    visitedCheck: false,
                    dateVisited: false,
                    dateVisitedRFC2822: false,
                    refusedCheck: false,
                    dateRefused: false,
                    dateRefusedRFC2822: false,
                    obtainingVisa: false,
                    obtainingVisaId: false,
                },*/
                step5: {
                    dateRefusedRFC2822: false,
                    visitedIranBefore: false,
                    visitedIranBeforeId: false,
                    visitedIranBeforeMonth : false,
                    visitedIranBeforeYear : false,
                    visitedCountries : false,
                    visitedCountriesId : false,
                    visitedIsrael : false,
                    visitedIsraelMonth : false,
                    visitedIsraelYear : false,
                    visitedUSA : false,
                    visitedUSAMonth : false,
                    visitedUSAYear : false,
                    visitedUK : false,
                    visitedUKMonth : false,
                    visitedUKYear : false,
                    visitedCanada : false,
                    visitedCanadaMonth : false,
                    visitedCanadaYear : false,
                    iranVisaDenial : false,
                    iranVisaDenialId : false,
                    dateRefused : false,
                    obtainingVisa : false,
                    obtainingVisaId : false,
                    iranVisaBefore : false,
                    iranVisaBeforeId : false,
                    typeFormerIranVisa : false,
                    hotelsPlaces : false,
                },
                step6: {
                    date: false,
                    dateRFC2822: false,
                    citiesRouter: {},
                },
                step7: {
                    validityInsurance: {
                        check: true,
                        days: '1',
                        prise: false,
                    },
                },
                step8: {
                    arrServDeliverCourierHotel: {
                        check: false,
                        prise: false,
                    },
                    arrServGetAirport: {
                        check: false,
                        prise: false,
                    },
                    arrServTransfer: {
                        check: false,
                        prise: false,
                    },
                    arrServMeetingAirport: {
                        check: false,
                        prise: false,
                    },
                    arrServCIPTerminal: {
                        check: false,
                        prise: false,
                    },
                    arrServBankSimCards: {
                        check: false,
                        prise: false,
                    },
                    departureServTransfer: {
                        check: false,
                        prise: false,
                    },
                    departureServCIPTerminal: {
                        check: false,
                        prise: false,
                    },
                    fastTrack: {
                        check: false,
                        prise: false,
                    },
                    fastTrackBusiness: {
                        check: false,
                        prise: false,
                    },
                },
                step9: {
                    payVisaOnline: false,
                    inn: false,
                    email: false,
                },
            },
            inputCleaningErrorSuccess: view.inputCleaningErrorSuccess,
            radioCleaningErrorSuccess: view.radioCleaningErrorSuccess,
            fileCleaningErrorSuccess: view.fileCleaningErrorSuccess,
            messageHtml: view.messageHtml,
            mgsHtmlInsurance: view.mgsHtmlInsurance,
            htmlText: view.htmlText,
            tableRowHtml: view.tableRowHtml,
            tableTotalPriseHtml: view.tableTotalPriseHtml,
            setStep2BusinessContainerHtml: view.setStep2BusinessContainerHtml,
            setStepLocalStorage: model.setStepLocalStorage,
            setDataFormAddLocalStorage: model.setDataFormAddLocalStorage,
            setInputClickLocalStorage: model.setInputClickLocalStorage,
            setRadioClickLocalStorage: model.setRadioClickLocalStorage,
            errorInputController: model.errorInputController,
            setTextInputDataForm: model.setTextInputDataForm,
            setTextRadioDataForm: model.setTextRadioDataForm,
            getStepLocalStorage: model.getStepLocalStorage,
            getNumWord: model.getNumWord,
            getNumberParser: model.getNumberParser,
            customSelectActive: model.customSelectActive,
            inputControlClickBtn: model.inputControlClickBtn,
            validateNum: model.validateNum,
            calculateAge: model.calculateAge,
            insuranceCost: model.insuranceCost,
            numberWithSpaces: model.numberWithSpaces,
            modalDialogSuccess: model.modalDialogSuccess,
            deleteSuccessErrorText: model.deleteSuccessErrorText,
        }

        this.fn = {
            getInputId: model.getInputId,
            getInputStepId: model.getInputStepId,
            getMobileDevise: model.getMobileDevise,
            delLocalStorage: model.delLocalStorage,
            delLocalStorageGetParam: model.delLocalStorageGetParam, //?delLS=Y&clear_cache=Y
            setBorderControlRadioLoad: view.setBorderControlRadioLoad,
            getParams: model.getParams,
            setCookieTimeReset: model.setCookieTimeReset,
            timeResetLS: model.timeResetLS,
            inputContainerClickRemoveError: view.inputContainerClickRemoveError,
        }

        this.page = {
            // contactInformation: contactInformation.stepContactInformation,
            personalInformation: personalInformation.stepPersonalInformation,
            loadingFile: loadingFile.stepLoadingFile,
            previousVisas: previousVisasNew.stepPreviousVisasNew,
            // previousVisas: previousVisas.stepPreviousVisas,
            travelPlans: travelPlans.stepTravelPlans,
            insurance: insurance.stepInsurance,
            specialOffers: specialOffers.stepSpecialOffers,
            payment: payment.stepPayment,
        }

        // Дебажим определённые страницы
        if (arParams.CONFIG.DEBUG === 'Y') {
            // this.page.previousVisas = previousVisasNew.stepPreviousVisasNew
        }

        if (typeof arParams === 'object')
        {
            this.params = arParams;
            this.visual = arParams['VISUAL'];
            this.message = arParams['MESSAGE'];
            this.utm = this.params['PARAMS']['UTM'];
        }

        if (this.errorCode === 0)
        {
            BX.ready(BX.delegate(this.dwsInit, this));
        } else {
            console.error(this.errorCode)
        }
    };

    window.JCDwsFormEVisaIran.prototype = {

        dwsInit: function ()
        {
            this.stepName = {
                1: 'type_of_visa',
                2: 'personal_information',
                3: 'loading_passport',
                4: 'uploading_photo',
                // 5: 'contact_information',
                // 5: 'previous_visas',
                5: 'previous_visas_new',
                6: 'travel_plans',
                7: 'insurance',
                8: 'special_offers',
                9: 'payment',
            }

            this.urlFolderAjaxPage = this.params.CONFIG.URL_FOLDER_AJAX_PAGE;
            this.urlFolderAjax = this.params.CONFIG.URL_FOLDER_AJAX;
            this.urlModalFormAnd = this.params.CONFIG.URL_MODAL_FORM_AND;
            this.formId = BX(this.visual['FORM_ID']);
            this.bannerId = BX(this.visual['BANNER_ID']);
            this.fvcContainerId = BX(this.visual['FVC_CONTAINER_ID']);
            this.btnWrapperId = BX(this.visual['BTN_WRAPPER_ID']);
            this.navStepId = BX(this.visual['NAV_STEP_ID']);
            this.locStorStepId = this.visual['LOCAL_STORAGE_STEP_ID'];
            this.stepId = this.visual['STEP_ID'];

            if (!this.urlFolderAjax) this.errorCode = -1;
            if (!this.urlFolderAjaxPage) this.errorCode = -2;
            if (!this.urlModalFormAnd) this.errorCode = -3;
            if (!this.bannerId) this.errorCode = -4;
            if (!this.formId) this.errorCode = -5;
            if (!this.fvcContainerId) this.errorCode = -10;
            if (!this.btnWrapperId) this.errorCode = -11;
            if (!this.navStepId) this.errorCode = -12;
            if (!this.locStorStepId) this.errorCode = -13;
            if (!this.stepId) this.errorCode = -14;

            this.bPrev = this.btnWrapperId.querySelector('.b_prev');
            this.bNext = this.btnWrapperId.querySelector('.b_next');


            // Дебажим определённые страницы
            if (this.params.CONFIG.DEBUG === 'Y') {
                // this.stepName[5] = 'previous_visas_new';

                // Очистка LocalStorage (?clear_cache=Y&dwsDelLS=Y)
                model.delLocalStorageGetParam(this, 'dwsDelLS', 1);
            }

            if (this.errorCode === 0)
            {
                // Переключатель видов через LocalStorage
                if (Number(this.data.getStepLocalStorage(this.stepId))) {
                    this.data.step = Number(this.data.getStepLocalStorage(this.stepId));
                }

                this.stepAjaxResult();

                // Доработка навигации под клик по ней
                model.setNavStepActive(this);

                BX.bind(this.bNext, 'click', BX.proxy(model.controlButtons, this));
                BX.bind(this.bPrev, 'click', BX.proxy(model.controlButtons, this));
                BX.bind(window, 'load', BX.proxy(model.loadControlPage, this));

            } else {
                console.error(this.errorCode)
            }
        },

        // Загрузка "STEP"
        stepAjaxResult: function ()
        {
            this.fvcContainerId.innerHTML = "";
            this.formId.dataset.step =  this.data.step;

            model.loadControlAjax(this);

            // Добавляем класс mobile_js
            view.addClassMobile ([this.bannerId, this.formId], model.getMobileDevise())

            // Меняем класс у родительских блоков на container-fluid
            view.addClassMobileFluid (this.bannerId, model.getMobileDevise())

            // Переключатель этапов в мобиле
            view.controlNavMobileStep (model.getMobileDevise(), this.navStepId, this.data.step);

            // По гет параметру переходим на первую страницу
            if (this.fn.getParams('radio') >= 1) {
                this.data.setStepLocalStorage(this.visual.STEP_ID, '1');
                this.data.step = 1;
            }

            // Если нет COOKIE устанавливаем ее и сбрасываем форму если есть обновляем ее
            if (!BX.getCookie(this.visual.COOKIE_ID)) {
                this.fn.setCookieTimeReset(this)
                this.fn.timeResetLS(this)
            } else {
                this.fn.setCookieTimeReset(this)
            }

            BX.ajax({
                method: 'POST',
                dataType: 'html',
                async: true,
                url: this.urlFolderAjaxPage + this.stepName[this.data.step]+'.php',
                data: {visual: this.visual, params: this.params['PARAMS'], message: this.message},
                onsuccess: BX.proxy(function (data){
                    this.fvcContainerId.insertAdjacentHTML("afterbegin", data);

                    navigation.activeNavStep(this.data.step, this.navStepId);

                    switch (this.data.step) {
                        case 1: // Вид визы
                            this.fvcTextPriceId = BX(this.visual['FVC_TEXT_PRICE_ID']);
                            if (!this.fvcTextPriceId) this.errorCode = -50;
                            // const inputs = this.fvcContainerId.querySelectorAll('.input_control_js');
                            // if (inputs) {
                            //     this.data.inputCleaningErrorSuccess(this.fvcContainerId);
                            //     this.model.inputControlClickBtn(inputs, this);
                            // }

                            this.bNext.classList.add('disabled');
                            typeOfVisa.activeRadioTypeOfVisa(this);
                            break;
                        case 2: // Персональные данные
                            this.data.inputCleaningErrorSuccess(this.fvcContainerId);
                            this.data.radioCleaningErrorSuccess(this.fvcContainerId)

                            model.setActiveCalendarLocalStorage(this, true);
                            this.page.personalInformation(this);
                            break;
                        case 3: // Загрузка паспорта
                            this.data.fileCleaningErrorSuccess(this.fvcContainerId);
                            model.inputDownloadFileControl(this);
                            this.page.loadingFile(this);
                            break;
                        case 4: // Загрузка фото
                            this.data.fileCleaningErrorSuccess(this.fvcContainerId);
                            model.inputDownloadFileControl(this);
                            this.page.loadingFile(this);
                            break;
                        /*case 5: // Контактная информация
                            this.data.inputCleaningErrorSuccess(this.fvcContainerId);
                            this.page.contactInformation(this)
                            break;*/
                        case 5: // Предыдущие визы
                            // model.customSelectActive(this);
                            model.setActiveCalendarLocalStorage(this);
                            this.page.previousVisas(this);
                            break;
                        case 6: // Планы по поездке
                            this.data.inputCleaningErrorSuccess(this.fvcContainerId);

                            model.setActiveCalendarLocalStorage(this);
                            this.page.travelPlans(this);
                            break;
                        case 7: // Страховка
                            // model.customSelectActive(this);
                            model.customBoxActive(this);
                            this.page.insurance(this);
                            break;
                        case 8: // Специальные предложения
                            model.customBoxActive(this);
                            this.page.specialOffers(this)
                            break;
                        case 9: // Оплата
                            this.page.payment(this)
                            break;
                    }
                }, this)
            });
        },
    };
}
